import { createFileRoute, Outlet } from '@tanstack/react-router'
import { DashboardAuthGate } from '~/features/auth/dashboard-auth-gate'
import { CreditPackReturn } from '~/features/billing/credit-pack-return'
import { CreditTopUpHost } from '~/features/billing/credit-top-up-dialog'
import { HostPublishHost } from '~/features/events/components/host-publish-dialog'
import { DashboardLayout } from '~/widgets/layout'

export const Route = createFileRoute('/dashboard')({
  component: DashboardRoute,
})

function DashboardRoute() {
  return (
    <DashboardAuthGate>
      <DashboardLayout>
        <CreditPackReturn />
        <CreditTopUpHost />
        <HostPublishHost />
        <Outlet />
      </DashboardLayout>
    </DashboardAuthGate>
  )
}
